var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHugeiconsCustomerSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8368 23.4109C36.8368 22.6612 36.8368 22.2864 36.9495 21.9527C37.2766 20.9821 38.1411 20.6072 39.0078 20.2129C39.9785 19.7687 40.4638 19.5477 40.947 19.5087C41.493 19.4654 42.0411 19.5824 42.5091 19.8446C43.1288 20.1912 43.5621 20.8542 44.0041 21.3916C46.0473 23.8746 47.07 25.1161 47.4426 26.4832C47.746 27.5882 47.746 28.7452 47.4426 29.8481C46.8988 31.8457 45.1763 33.5184 43.9001 35.0697C43.248 35.8606 42.9208 36.2571 42.5091 36.4889C42.0331 36.7529 41.4894 36.8698 40.947 36.8247C40.4638 36.7857 39.9785 36.5647 39.0056 36.1206C38.139 35.7262 37.2766 35.3514 36.9495 34.3807C36.8368 34.0471 36.8368 33.6722 36.8368 32.9226V23.4109ZM15.1701 23.4109C15.1701 22.4662 15.1441 21.6191 14.3815 20.9561C14.1041 20.7156 13.7358 20.5487 13.0013 20.2129C12.0285 19.7709 11.5431 19.5477 11.06 19.5087C9.6148 19.3917 8.83696 20.3797 8.00496 21.3937C5.95963 23.8746 4.93696 25.1161 4.56213 26.4854C4.26054 27.5867 4.26054 28.7489 4.56213 29.8502C5.10813 31.8457 6.8328 33.5206 8.1068 35.0697C8.91063 36.0447 9.6798 36.9352 11.06 36.8247C11.5431 36.7857 12.0285 36.5647 13.0013 36.1206C13.738 35.7869 14.1041 35.6179 14.3815 35.3774C15.1441 34.7144 15.1701 33.8672 15.1701 32.9247V23.4109Z",
    stroke: "white",
    strokeWidth: 3.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8359 19.5C10.8359 12.3197 17.6263 6.5 26.0026 6.5C34.3789 6.5 41.1693 12.3197 41.1693 19.5M41.1693 36.8333V38.5667C41.1693 42.3952 37.2909 45.5 32.5026 45.5H28.1693",
    stroke: "white",
    strokeWidth: 3.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsCustomerSupport);
export default __webpack_public_path__ + "static/media/hugeicons_customer-support.4b9539f93e8e190699a0c14b90d92b0d.svg";
export { ForwardRef as ReactComponent };